/* Rastreio do seletor do Primer e do Compre Junto no pedido da Yampi (TechEcom, 20/10/2026).
   O seletor (assets/aura-seletor-qtd.js) grava no localStorage, por 24 h:
     ymp_sel = { ids: [variant_id], q: qtd escolhida, p: handle, t: template, exp }
     ymp_cj  = { v: [{ id: variant_id, s: handle, o: origem }], exp }
   O snippets/YampiSnippet.liquid chama, em todo caminho até o checkout:
     auraRastreio.filtrar(cartPayload)  logo depois de ler /cart.json: só fica a marca de item que AINDA está no carrinho
     auraRastreio.aplicar(url)          dentro de ymp_getUrlWithUtms: grava metadata[seletor], metadata[compre_junto],
                                        metadata[cj_itens] e metadata[cj_origem] na URL, que a Yampi grava no pedido.
   Valor de metadata[seletor]: "pagina|qtd_escolhida|template". Sem dado pessoal. */
(function () {
  if (window.auraRastreio) return;

  function ler(chave, campo) {
    try {
      var d = JSON.parse(localStorage.getItem(chave) || 'null');
      if (!d || !d[campo] || !d[campo].length) return null;
      if (d.exp && Date.now() > d.exp) {
        localStorage.removeItem(chave);
        return null;
      }
      return d;
    } catch (e) {
      return null;
    }
  }

  function noCarrinho(cartPayload) {
    var m = {};
    if (cartPayload && cartPayload.items) {
      for (var i = 0; i < cartPayload.items.length; i++) m[cartPayload.items[i].variant_id] = true;
    }
    return m;
  }

  function filtrar(cartPayload) {
    var m = noCarrinho(cartPayload);
    try {
      var s = ler('ymp_sel', 'ids');
      if (s) {
        var fica = false;
        for (var j = 0; j < s.ids.length; j++) {
          if (m[s.ids[j]]) {
            fica = true;
            break;
          }
        }
        if (!fica) localStorage.removeItem('ymp_sel');
      }
    } catch (e) {}
    try {
      var c = ler('ymp_cj', 'v');
      if (c) {
        var kept = [];
        for (var k = 0; k < c.v.length; k++) {
          if (m[c.v[k].id]) kept.push(c.v[k]);
        }
        if (kept.length) localStorage.setItem('ymp_cj', JSON.stringify({ v: kept, exp: c.exp }));
        else localStorage.removeItem('ymp_cj');
      }
    } catch (e) {}
  }

  function aplicar(url) {
    try {
      var c = ler('ymp_cj', 'v');
      if (c) {
        var itens = [];
        var origens = [];
        for (var i = 0; i < c.v.length && i < 6; i++) itens.push(c.v[i].s || String(c.v[i].id));
        for (var o = 0; o < c.v.length; o++) {
          var org = c.v[o].o;
          if (org && origens.indexOf(org) === -1) origens.push(org);
        }
        url.searchParams.set('metadata[compre_junto]', 'sim');
        url.searchParams.set('metadata[cj_itens]', itens.join(','));
        if (origens.length) url.searchParams.set('metadata[cj_origem]', origens.join(','));
      }
      var s = ler('ymp_sel', 'ids');
      if (s) url.searchParams.set('metadata[seletor]', String(s.p || '') + '|' + String(s.q || '') + '|' + String(s.t || ''));
    } catch (e) {}
    return url;
  }

  window.auraRastreio = { filtrar: filtrar, aplicar: aplicar };
})();
